import React from 'react';
import BetaLaunchBanner from '../components/BetaLaunchBanner';

interface AuthLayoutProps {
    children: React.ReactNode;
    title: string;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children, title }) => {
    return (
        <div className="flex min-h-screen bg-surface">
            <div className="flex flex-1 items-center justify-center px-6 py-10 sm:px-10 lg:px-16">
                <div className="w-full max-w-md">
                    <div className="mb-8 text-center">
                        <img src='/logos/flowium_banner.svg' alt="Flowium Logo" className="mx-auto max-w-[220px]" />
                    </div>
                    <div className="mb-8">
                        <BetaLaunchBanner variant="hero" />
                    </div>
                    <div className="text-center">
                        <h1 className="text-3xl font-semibold text-content">{title}</h1>
                        <p className="mt-2 text-sm text-content-secondary">
                            Manage files, collaborators, and workflows from one workspace.
                        </p>
                    </div>
                    <div className="mt-8">
                        {children}
                    </div>
                </div>
            </div>

            <div className="hidden lg:flex lg:w-[42%] lg:items-center lg:justify-center lg:overflow-hidden lg:border-l lg:border-secondary lg:bg-surface-secondary lg:p-4">
                <img
                    src='/images/geometric_10.webp'
                    alt="Auth Illustration"
                    className="h-full w-full rounded-3xl object-cover"
                />
            </div>
        </div>
    );
};

export default AuthLayout;
